
'use strict';

define('mixins/ViewHelpersMixin.js',['require','react','create-react-class','underscore','classnames'],function (require) {

  var React = require('react');
  var ReactCreateClass = require('create-react-class');
  var _ = require('underscore');
  var cx = require('classnames');

  var Button = ReactCreateClass({
    getDefaultProps: function getDefaultProps() {
      return {
        rootClass: 'button-new',
        modifierClass: 'primary',
        link: '#',
        icon: null,
        iconAlign: 'left',
        tabIndex: '0'
      };
    },

    getIconMarkup: function getIconMarkup(children) {
      var classes = cx({
        'button-with-icon': true,
        'icon-align-right': this.props.iconAlign === 'right'
      });

      if (this.props.iconAlign === 'left') {
        return React.createElement(
          'div',
          { className: classes },
          React.createElement('div', { className: 'left icon-16 ' + this.props.icon }),
          React.createElement(
            'div',
            { className: 'text' },
            children
          )
        );
      } else {
        return React.createElement(
          'div',
          { className: classes },
          React.createElement(
            'div',
            { className: 'text' },
            children
          ),
          React.createElement('div', { className: 'left icon-16 ' + this.props.icon })
        );
      }
    },

    render: function render() {
      var classes = [this.props.rootClass, this.props.modifierClass].join(' ');

      if (this.props.element === 'button') {
        return React.createElement(
          'button',
          { className: classes, tabIndex: this.props.tabIndex, onClick: this.props.onClick },
          !_.isNull(this.props.icon) ? this.getIconMarkup(this.props.children) : this.props.children
        );
      } else {
        return React.createElement(
          'a',
          { className: classes, tabIndex: this.props.tabIndex, onClick: this.props.onClick, href: this.props.link },
          this.props.children
        );
      }
    }
  });

  return {
    helpers: {
      Button: Button
    }
  };
});
